import { Link } from "react-router-dom";
import Header from "../Header";
import "../../styles/help/HelpSubscreenTemplate.css";
import loginImg from "../../assets/login.jpg";
import signUpImg from "../../assets/signUp.jpg";

import { useTranslation } from "react-i18next";

export default function HelpLogin() {
  const { t } = useTranslation("help");

  return (
    <div className="help-subscreen-template">
      <div className="theme-whbl">
        <div className="container-fluid">
          <div className="main-container">

            <main>
              <div className="dashboard">

                {/* Page Header */}
                <div className="pm-header">
                  <div className="pm-title-section">
                    <h1 className="pm-title">
                      {t("loginAndSignup.title")}
                    </h1>
                  </div>
                </div>

                {/* Login Section */}
                <div
                  className="help-content-section"
                  style={{
                    marginTop: "1rem",
                    width: "100%",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: "30%",
                      float: "left",
                      paddingTop: "20px",
                    }}
                  >
                    {t("loginAndSignup.steps.step1")}
                  </div>

                  <div
                    style={{
                      width: "70%",
                      float: "left",
                    }}
                  >
                    <img
                      src={t("loginAndSignup.image")}
                      alt={t("loginAndSignup.loginImageAlt")}
                      width="100%"
                    />
                  </div>

                  {/* Sign Up Section */}
                  <div
                    style={{
                      width: "30%",
                      float: "left",
                      paddingTop: "20px",
                    }}
                  >
                    {t("loginAndSignup.steps.step2")}
                  </div>

                  <div
                    style={{
                      width: "70%",
                      float: "left",
                      paddingTop: "20px",
                    }}
                  >
                    <img
                      src={t("loginAndSignup.image2")}
                      alt={t("loginAndSignup.signUpImageAlt")}
                      width="100%"
                    />
                  </div>
                </div>

              </div>
            </main>

          </div>
        </div>
      </div>
    </div>
  );
}

